/**
 * a hook that fetches announcement data and displays a modal for that data
 * see also the corresponding client hook
 * @file useAnnouncementModal
 * @author Julius Diaz Panoriñgan
 */

import React, { useEffect, useMemo } from 'react'

import AnnouncementModal from 'shared/components/AnnouncementModal'
import useAnnouncementsData from 'shared/hooks/useAnnouncementsData'
import { useModal } from 'shared/hooks/useModal'

/**
 * @function useAnnouncementModal
 * @param {Object} profile user profile, from which role and announcement status are read
 */
const useAnnouncementModal = profile => {
  const { announcement, nextAnnouncement } = useAnnouncementsData(profile)

  const renderAnnouncement = useMemo(
    () =>
      announcement && (
        <AnnouncementModal
          content={announcement.content}
          dismiss={nextAnnouncement}
          title={announcement.title}
        />
      ),
    [announcement]
  )

  const [showModal, hideModal] = useModal(renderAnnouncement)

  useEffect(() => {
    if (announcement) {
      // *must* be called again when announcement and renderAnnouncement change;
      // if not, the rendered modal does not update
      showModal()
    } else {
      hideModal()
    }
  }, [announcement])
}

export default useAnnouncementModal
